module.exports = "<div class=\"stagedAmountDisplay-container\">\r\n    <span class=\"stagedAmountDisplay-description\" ng-if=\"$ctrl.showDescription\">Payment to be deducted</span>\r\n    <div class=\"stagedAmountDisplay-innerContainer\">\r\n        <span class=\"stagedAmountDisplay-label\">PAYING</span>\r\n        <span class=\"stagedAmountDisplay-amount\">{{$ctrl.payingAmount | currency}}</span>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/digitalpay/staged-amount-display.component.html
// module id = 969
// module chunks = 1